<template>
	<div class="about">
		<Header :typeHeader="'defaultHeader'">
			<!-- banner -->
			<img slot="headerImage" src="../assets/About/banner.jpg" alt="">
			<!-- 标题 -->
			<div slot="headerTitle">{{$store.state.navShow == true ? 'Margin Group 全球客户的忠实伙伴' : 'Loyal partner to Global Customers'}}</div>
		</Header>

		<div class="aboutTitleImg" data-aos="fade-up">
			<img src="../assets/About/topImg.png">
			<div class="">
				{{$store.state.navShow == true ? $route.name : $route.meta.EnName}}
			</div>
		</div>
		<!-- <div class="aboutText" :html="usContent" > -->
		<div class="aboutText" v-html="$store.state.navShow == true ? usContent : usContentE" :style="$store.state.navShow == true? '' : 'text-align: justify;'">

			<!-- <p>Margin Group（简称：MG集团）总部位于俄罗斯圣彼得堡，是一家致力于为中俄、西欧的商贸企业提供国际物流、进出口贸易、报关清关、供应链等服务的跨国集团企业。在莫斯科、海参崴、白俄罗斯设立分公司，在中国上海、河北、海南、香港设立4家分公司。
			</p>
			<p>MG集团在俄罗斯拥有成熟的国际物流资源，在中国市场拥有稳定的国际运输线路及多式联运经验，在中欧班列线路开拓、海运服务、空运服务、俄罗斯及欧洲国家的清关服务、境外陆运及配送服务、海外仓及国际贸易等方面形成了高质量特色服务及品牌。</p>
			<p>MG集团凭借多年中俄供应链服务经验，专注于国际贸易与国际物流两大关键领域。“立足供应链，服务产业链，创造价值链”，MG将通过”物流带动贸易流通，贸易延伸物流价值”的运贸一体化服务能力，沿着产业链向上下游延伸，提供外贸交易流通、“站到站”“门到门”全程物流、供应链、信息咨询等全价值链流通服务，为全球客户提供优质便捷的采购供应及综合物流服务。</p> -->
		</div>

		<div class="target">
			<div class="target_List" v-for="(item,index) in $store.state.navShow == true ? globalArr : globalArrE" :key="index" data-aos="fade-up">
				<div class="target_ListCon">
					<img :src="item.globalImgIcon">
					<div class="target_ListConText">{{ item.globalTitle }}</div>
				</div>
			</div>
		</div>

		<div class="staff">
			<img class="staffBanner" src="../assets/About/banner2.jpg" data-aos="fade-right">
			<div class="staffText" data-aos="fade-right">
				<div class="staffTextTitle">{{$store.state.navShow == true ? '每一天都极度认真' : 'Extremely conscientious every day'}}</div>
				<div class="staffTextCon">{{$store.state.navShow == true ?'MG集团在俄罗斯、白俄罗斯、德国、英国拥有本土国际贸易服务团队，其中俄罗斯境内分公司5家，俄方员工占95%':'We have international trade service team in Russia, Belarus, Germany, UK, 5 branch offices in Russia with 95% of Russian employees.'}}</div>
			</div>
		</div>

		<div class="staffImg" data-aos="fade-up">
			<img class="staffImgIn" :src="item.img" v-for="(item,index) in staffImgList" :key="index">
		</div>
	</div>
</template>
<script type="text/javascript">
	import Header from "@/components/header.vue";
	// import Footer from "@/components/footers.vue";
	export default {
		components: {
			Header,
			// Footer
		},
		data() {
			return {
				usContent: 'Margin Group（简称：MG集团）总部位于俄罗斯圣彼得堡，是一家致力于为中俄、西欧的商贸企业提供国际物流、进出口贸易、报关清关、供应链等服务的跨国集团企业。在莫斯科、海参崴、白俄罗斯设立分公司，在中国上海、河北、海南、香港设立4家分公司。<br>MG集团在俄罗斯拥有成熟的国际物流资源，在中国市场拥有稳定的国际运输线路及多式联运经验，在中欧班列线路开拓、海运服务、空运服务、俄罗斯及欧洲国家的清关服务、境外陆运及配送服务、海外仓及国际贸易等方面形成了高质量特色服务及品牌。<br>MG集团凭借多年中俄供应链服务经验，专注于国际贸易与国际物流两大关键领域。“立足供应链，服务产业链，创造价值链”，MG将通过”物流带动贸易流通，贸易延伸物流价值”的运贸一体化服务能力，沿着产业链向上下游延伸，提供外贸交易流通、“站到站”“门到门”全程物流、供应链、信息咨询等全价值链流通服务，为全球客户提供优质便捷的采购供应及综合物流服务。', // 关于我们内容
				usContentE: 'Margin group (MG Group for short), headquartered in St. Petersburg, Russia, is a multinational enterprise committed to providing international logistics, import and export trade, customs clearance, supply chain and other services to commercial enterprises in China, Russia and Western Europe. We have set up branches in Moscow, Vladivostok and Belarus, and four branches in Shanghai, Hebei, Hainan and Hong Kong.We have mature international logistics resources in the Russia market and stable experience in international transportation routes and multimodal transport in the Chinese market.The company formed high-quality characteristic services and brands in the development of China Europe train routes, maritime services, air transport services, customs clearance services in Russia and European countries, overseas land transportation and distribution services, overseas warehouses and international trade.With years of experience in Sino-Russian supply chain services, we focus on two key areas: International Trade and international logistics. "Based on the supply chain, serving the industrial chain, and creating the value chain". Mg will extend up and down the industrial chain through the transportation and trade integration service capability of "logistics drives trade circulation, and trade extends logistics value", providing foreign trade transaction circulation, "station to station", "door to door" whole process logistics, supply chain, information consulting and other full value chain circulation services, and provide high-quality and convenient procurement, supply and comprehensive logistics services for global customers.',
				// usContent: [],
				globalArr: [{
						globalImgIcon: require('../assets/About/globalIcon1.png'),
						globalTitle: '全球客户的忠实伙伴'
					},
					{
						globalImgIcon: require('../assets/About/globalIcon2.png'),
						globalTitle: '全球行业的行为典范'
					},
					{
						globalImgIcon: require('../assets/About/globalIcon3.png'),
						globalTitle: '全球员工的最佳雇主'
					},
					{
						globalImgIcon: require('../assets/About/globalIcon4.png'),
						globalTitle: '全球公众的信赖品牌'
					}
				],

					globalArrE: [{
						globalImgIcon: require('../assets/About/globalIcon1.png'),
						globalTitle: 'Loyal partner of global customers'
					},
					{
						globalImgIcon: require('../assets/About/globalIcon2.png'),
						globalTitle: 'A role model for the global industry'
					},
					{
						globalImgIcon: require('../assets/About/globalIcon3.png'),
						globalTitle: 'Best Employers for Global Employees'
					},
					{
						globalImgIcon: require('../assets/About/globalIcon4.png'),
						globalTitle: 'A trusted brand for the global public'
					}
				],
				staffImgList: [{
						img: require('../assets/About/yuangong1.jpg'),
						id: 1,
					},
					{
						img: require('../assets/About/yuangong2.jpg'),
						id: 2,
					},
					{
						img: require('../assets/About/yuangong3.jpg'),
						id: 3,
					},
					{
						img: require('../assets/About/yuangong4.jpg'),
						id: 4,
					},
				],
			}
		},
		mounted() {
			/**
			 * 关于我们seo与企业介绍
			 * 罗锦炜
			 * 2021-12-03
			 */
			// this.$axios.get('/api/About/index').then(res => {
			// 	// console.log('关于我们=>',res)
			// 	if (res.data.code === 1) {
			// 		this.usContent = res.data.data.content // 企业介绍
			// 	} else {
			// 		this.$message({
			// 			showClose: true,
			// 			message: '企业介绍' + res.data.msg,
			// 			type: 'error'
			// 		})
			// 	}
			// })
		},
		methods: {

		}
	}
</script>
<style lang="less">
	.aboutTitleImg {
		width: 92%;
		height: 15rem;
		position: relative;
		margin: 0 4%;
		top: -3.2rem;

		img {
			height: 100%;
			width: 100%;
		}

		&>div {
			position: absolute;
			top: 1.25rem;
			font-size: 1rem;
			font-family: Microsoft YaHei;
			font-weight: bold;
			color: #FFFFFF;
			padding: 1.2rem 3.375rem 1.2rem 0.75rem;
			background: #2e67b1 linear-gradient(270deg, rgba(3, 0, 0, .15), hsla(0, 0%, 100%, .15));
		}
	}

	.aboutText {
		width: 92%;
		margin: 0 4%;
		// background-color: #000066;
		margin-top: -1.575rem;
		text-align: left;
		margin-bottom: 10px;

		&>p {
			font-size: 0.875rem;
			font-family: Microsoft YaHei;
			font-weight: 400;
			color: #666666;
			text-indent: 2em;
			margin-bottom: 1.25rem;
		}

		.aboutText_1 {}
	}

	.target {
		width: 92%;
		margin: 0 auto;
		margin: 0 4%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		margin-bottom: 2rem;

		.target_List {
			width: 46%;
			height: 4.6875rem;
			background: linear-gradient(321deg, #3676c9, #42be72);
			margin-bottom: 4%;
			display: flex;
			flex-direction: column;
			justify-content: center;
			align-items: center;

			.target_ListCon {
				&>.target_ListConText {
					font-size: 0.6875rem;
					font-family: Microsoft YaHei;
					font-weight: 400;
					color: #F8F8F8;
				}
			}
		}

		.target_List:nth-child(1) {
			margin-right: 4%;

			&>.target_ListCon {
				&>img {
					width: 2.03125rem;
					height: 1.65625rem;
				}
			}
		}

		.target_List:nth-child(2) {
			&>.target_ListCon {
				&>img {
					width: 1.75rem;
					height: 1.5625rem;
				}
			}
		}

		.target_List:nth-child(3) {
			margin-right: 4%;

			&>.target_ListCon {
				&>img {
					width: 1.625rem;
					height: 1.5rem;
				}
			}
		}

		.target_List:nth-child(4) {
			&>.target_ListCon {
				&>img {
					width: 1.53125rem;
					height: 1.71875rem;
				}
			}
		}
	}

	.staff {
		width: 92%;
		margin: 0 4%;
		margin-bottom: 20px;
		background-color: rgba(46, 103, 177, 1);

		.staffBanner {
			width: 100%;
			height: 12.5rem;
		}

		.staffText {
			width: 100%;
			text-align: left;
			padding-top: 1.1rem;

			&>div {
				margin-left: 0.96875rem;
				margin-right: 0.96875rem;
			}

			.staffTextTitle {
				margin-bottom: 1.1875rem;
				font-size: 0.9375rem;
				font-family: Microsoft YaHei;
				font-weight: bold;
				color: #FFFFFF;
			}

			.staffTextCon {
				font-size: 0.6875rem;
				font-family: Microsoft YaHei;
				font-weight: 400;
				color: #FFFFFF;
				line-height: 1.25rem;
				padding-bottom: 1.84375rem;
			}
		}
	}

	.staffImg {
		width: 92%;
		margin: 0 4%;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-wrap: wrap;
		margin-bottom: 2.1875rem;

		.staffImgIn {
			width: 46%;
			height: 6.875rem;
			margin-bottom: 4%;
		}

		.staffImgIn:nth-child(1) {
			margin-right: 4%;
		}

		.staffImgIn:nth-child(3) {
			margin-right: 4%;
		}
	}
</style>
